import { render, staticRenderFns } from "./ContractEditor.vue?vue&type=template&id=bdfac8f6&"
import script from "./ContractEditor.vue?vue&type=script&lang=js&"
export * from "./ContractEditor.vue?vue&type=script&lang=js&"
import style0 from "./ContractEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports